$(document).ready(function () {
  const recommendations = document.querySelector(
    ".collection product-recommendations",
  );

  function myTimer() {
    if (recommendations.classList.contains("product-recommendations--loaded")) {
      myStopFunction();
      const cfcSlider = document.querySelector(".cfc-section slider-component");
      const breakpoint = window.matchMedia("(min-width:990px)");
      let cfcSwipes;

      const breakpointChecker = function () {
        if (
          breakpoint.matches === true &&
          !cfcSlider.classList.contains("slider-component-desktop")
        ) {
          if (cfcSwipes !== undefined) cfcSwipes.destroy(true, true);
          return;
        } else {
          return enableSwiper();
        }
      };

      const enableSwiper = function () {
        cfcSwipes = new Swiper(".cfc-section .swiper-container", {
          slidesPerView: "auto",
          centeredSlides: false,
          spaceBetween: 12,
          pagination: {
            el: ".cfc-section .swiper-pagination",
            clickable: true,
          },
          scrollbar: {
            el: ".cfc-section .swiper-scrollbar",
            draggable: true,
          },
          navigation: {
            nextEl: ".cfc-section .swiper-next-btn",
            prevEl: ".cfc-section .swiper-prev-btn",
          },
          breakpoints: {
            989: {
              slidesPerView: "auto",
            },
            1279: {
              slidesPerView: "auto",
            },
            3000: {
              slidesPerView: "auto",
            },
          },
        });
      };

      breakpoint.addListener(breakpointChecker);
      breakpointChecker();
    }
  }

  function myStopFunction() {
    clearInterval(myInterval);
  }

  const myInterval = setInterval(myTimer, 300);
});
